import type { LucideIcon } from "lucide-react";
import {
  Activity,
  Ambulance,
  Award,
  Baby,
  BadgePercent,
  Banknote,
  BookOpen,
  Bookmark,
  Brain,
  Briefcase,
  Building2,
  Calculator,
  CalendarDays,
  ChartColumn,
  CircleCheck,
  CircleDollarSign,
  ClipboardList,
  ClipboardPlus,
  Clock,
  Compass,
  Cpu,
  CreditCard,
  Cross,
  Database,
  Ear,
  Eye,
  Factory,
  FileCheck,
  FileText,
  Flag,
  Gavel,
  Globe,
  GraduationCap,
  Handshake,
  HardDrive,
  Heart,
  HeartPulse,
  Hospital,
  Key,
  Landmark,
  Laptop,
  Leaf,
  Lightbulb,
  Lock,
  Mail,
  MapPin,
  Megaphone,
  MessageCircle,
  Microscope,
  Monitor,
  NotebookPen,
  Package,
  Phone,
  PiggyBank,
  Pill,
  Printer,
  Receipt,
  Scale,
  ScrollText,
  Server,
  Settings,
  Shield,
  ShieldCheck,
  ShieldPlus,
  Smartphone,
  Sparkles,
  Stamp,
  Star,
  Stethoscope,
  Store,
  Syringe,
  Target,
  Thermometer,
  TrendingUp,
  Truck,
  UserRound,
  Users,
  Wallet,
  Wifi,
  Zap,
} from "lucide-react";

export const DEFAULT_SERVICE_ICON = "briefcase";
export const DEFAULT_SERVICE_ICON_COLOR = "#2563EB";

export const SERVICE_ICON_COLORS = [
  "#2563EB",
  "#0EA5E9",
  "#0D9488",
  "#10B981",
  "#84CC16",
  "#F59E0B",
  "#F97316",
  "#E11D48",
  "#DB2777",
  "#8B5CF6",
  "#6366F1",
  "#64748B",
] as const;

export type ServiceIconOption = {
  value: string;
  label: string;
  keywords: string;
  icon: LucideIcon;
};

export const SERVICE_ICON_CATALOG: ServiceIconOption[] = [
  { value: "stethoscope", label: "Sztetoszkóp", keywords: "orvos egészség praxis", icon: Stethoscope },
  { value: "heart-pulse", label: "Pulzus", keywords: "szív egészség kardiológia", icon: HeartPulse },
  { value: "heart", label: "Szív", keywords: "egészség gondoskodás", icon: Heart },
  { value: "activity", label: "Aktivitás", keywords: "egészség monitor", icon: Activity },
  { value: "pill", label: "Gyógyszer", keywords: "patika gyógyszerészet", icon: Pill },
  { value: "syringe", label: "Fecskendő", keywords: "oltás injekció", icon: Syringe },
  { value: "hospital", label: "Kórház", keywords: "klinika ellátás", icon: Hospital },
  { value: "cross", label: "Kereszt", keywords: "egészügy mentő", icon: Cross },
  { value: "ambulance", label: "Mentő", keywords: "sürgősség mentés", icon: Ambulance },
  { value: "brain", label: "Agy", keywords: "neurológia pszichológia", icon: Brain },
  { value: "eye", label: "Szem", keywords: "szemészet látás", icon: Eye },
  { value: "ear", label: "Fül", keywords: "fülészet hallás", icon: Ear },
  { value: "baby", label: "Baba", keywords: "gyermek pediátria", icon: Baby },
  { value: "microscope", label: "Mikroszkóp", keywords: "labor diagnosztika", icon: Microscope },
  { value: "thermometer", label: "Hőmérő", keywords: "láz vizsgálat", icon: Thermometer },
  { value: "shield-plus", label: "Pajzs plusz", keywords: "védelem biztosítás", icon: ShieldPlus },
  { value: "clipboard-plus", label: "Klipboard plusz", keywords: "karton dokumentáció", icon: ClipboardPlus },
  { value: "scale", label: "Mérleg", keywords: "jog igazság", icon: Scale },
  { value: "gavel", label: "Bírói kalapács", keywords: "jog per", icon: Gavel },
  { value: "file-text", label: "Dokumentum", keywords: "irat szerződés", icon: FileText },
  { value: "file-check", label: "Ellenőrzött fájl", keywords: "jóváhagyás irat", icon: FileCheck },
  { value: "stamp", label: "Pecsét", keywords: "hivatalos hitelesítés", icon: Stamp },
  { value: "scroll-text", label: "Tekercs", keywords: "szabályzat szerződés", icon: ScrollText },
  { value: "shield", label: "Pajzs", keywords: "védelem biztosítás", icon: Shield },
  { value: "shield-check", label: "Ellenőrzött pajzs", keywords: "biztonság megfelelés", icon: ShieldCheck },
  { value: "landmark", label: "Épület", keywords: "hivatal pályázat", icon: Landmark },
  { value: "calculator", label: "Számológép", keywords: "könyvelés pénzügy", icon: Calculator },
  { value: "wallet", label: "Pénztárca", keywords: "pénz díj", icon: Wallet },
  { value: "receipt", label: "Számla", keywords: "számla könyvelés", icon: Receipt },
  { value: "circle-dollar-sign", label: "Dollár", keywords: "pénz díjazás", icon: CircleDollarSign },
  { value: "badge-percent", label: "Százalék", keywords: "kedvezmény adó", icon: BadgePercent },
  { value: "piggy-bank", label: "Malacpersely", keywords: "megtakarítás", icon: PiggyBank },
  { value: "credit-card", label: "Bankkártya", keywords: "fizetés", icon: CreditCard },
  { value: "banknote", label: "Bankjegy", keywords: "készpénz", icon: Banknote },
  { value: "chart-column", label: "Oszlopdiagram", keywords: "statisztika riport", icon: ChartColumn },
  { value: "trending-up", label: "Növekedés", keywords: "fejlődés bevétel", icon: TrendingUp },
  { value: "monitor", label: "Monitor", keywords: "it számítógép", icon: Monitor },
  { value: "laptop", label: "Laptop", keywords: "it eszköz", icon: Laptop },
  { value: "smartphone", label: "Telefon", keywords: "mobil app", icon: Smartphone },
  { value: "wifi", label: "Wifi", keywords: "hálózat internet", icon: Wifi },
  { value: "server", label: "Szerver", keywords: "infrastruktúra", icon: Server },
  { value: "database", label: "Adatbázis", keywords: "adat it", icon: Database },
  { value: "cpu", label: "Processzor", keywords: "hardver it", icon: Cpu },
  { value: "hard-drive", label: "Merevlemez", keywords: "tárolás", icon: HardDrive },
  { value: "printer", label: "Nyomtató", keywords: "iroda eszköz", icon: Printer },
  { value: "briefcase", label: "Aktatáska", keywords: "üzlet menedzsment", icon: Briefcase },
  { value: "building-2", label: "Iroda", keywords: "praxis cég", icon: Building2 },
  { value: "factory", label: "Üzem", keywords: "ipar", icon: Factory },
  { value: "store", label: "Üzlet", keywords: "kereskedelem", icon: Store },
  { value: "users", label: "Csoport", keywords: "közösség csapat", icon: Users },
  { value: "user-round", label: "Személy", keywords: "páciens ügyfél", icon: UserRound },
  { value: "handshake", label: "Kézfogás", keywords: "megállapodás partner", icon: Handshake },
  { value: "clipboard-list", label: "Lista", keywords: "feladat igény", icon: ClipboardList },
  { value: "notebook-pen", label: "Jegyzet", keywords: "tanácsadás", icon: NotebookPen },
  { value: "calendar-days", label: "Naptár", keywords: "időpont esemény", icon: CalendarDays },
  { value: "clock", label: "Óra", keywords: "idő ügyelet", icon: Clock },
  { value: "map-pin", label: "Helyszín", keywords: "cím rendelő", icon: MapPin },
  { value: "truck", label: "Teherautó", keywords: "szállítás logisztika", icon: Truck },
  { value: "package", label: "Csomag", keywords: "eszközbeszerzés", icon: Package },
  { value: "star", label: "Csillag", keywords: "kiemelt minőség", icon: Star },
  { value: "award", label: "Díj", keywords: "minősítés", icon: Award },
  { value: "sparkles", label: "Csillogás", keywords: "új prémium", icon: Sparkles },
  { value: "lightbulb", label: "Villanykörte", keywords: "ötlet tanácsadás", icon: Lightbulb },
  { value: "settings", label: "Beállítások", keywords: "üzemeltetés", icon: Settings },
  { value: "lock", label: "Zár", keywords: "adatvédelem biztonság", icon: Lock },
  { value: "key", label: "Kulcs", keywords: "hozzáférés", icon: Key },
  { value: "mail", label: "Levél", keywords: "e-mail kapcsolat", icon: Mail },
  { value: "phone", label: "Telefon", keywords: "hívás ügyfélszolgálat", icon: Phone },
  { value: "message-circle", label: "Üzenet", keywords: "chat kommunikáció", icon: MessageCircle },
  { value: "bookmark", label: "Könyvjelző", keywords: "mentés", icon: Bookmark },
  { value: "flag", label: "Zászló", keywords: "jelzés", icon: Flag },
  { value: "globe", label: "Földgömb", keywords: "web nemzetközi", icon: Globe },
  { value: "book-open", label: "Könyv", keywords: "tudás képzés", icon: BookOpen },
  { value: "graduation-cap", label: "Kalap", keywords: "képzés oktatás", icon: GraduationCap },
  { value: "megaphone", label: "Megafon", keywords: "kommunikáció marketing", icon: Megaphone },
  { value: "leaf", label: "Levélke", keywords: "zöld környezet", icon: Leaf },
  { value: "zap", label: "Villám", keywords: "gyors energia", icon: Zap },
  { value: "target", label: "Célpont", keywords: "cél stratégia", icon: Target },
  { value: "compass", label: "Iránytű", keywords: "orientáció", icon: Compass },
  { value: "circle-check", label: "Pipa", keywords: "kész megfelelés", icon: CircleCheck },
];

const ICON_MAP = Object.fromEntries(
  SERVICE_ICON_CATALOG.map((item) => [item.value, item.icon]),
) as Record<string, LucideIcon>;

const CATEGORY_ICON_FALLBACK: Record<string, string> = {
  biztositas: "shield",
  "it-es-eszkozbeszerzes": "monitor",
  "jogi-tanacsadas": "scale",
  konyveles: "calculator",
  palyazatok: "landmark",
  praxismenedzsment: "briefcase",
};

export function isServiceIconName(value: string | null | undefined): value is string {
  return Boolean(value && ICON_MAP[value]);
}

export function getServiceIconOption(value: string | null | undefined) {
  return SERVICE_ICON_CATALOG.find((item) => item.value === value) ?? null;
}

export function getCatalogServiceIcon(
  iconName: string | null | undefined,
  categorySlug?: string | null,
): LucideIcon {
  if (iconName && ICON_MAP[iconName]) {
    return ICON_MAP[iconName];
  }

  const fallback = categorySlug ? CATEGORY_ICON_FALLBACK[categorySlug] : null;
  if (fallback && ICON_MAP[fallback]) {
    return ICON_MAP[fallback];
  }

  return Briefcase;
}

export function normalizeServiceIconColor(value: string | null | undefined) {
  if (value && /^#[0-9A-Fa-f]{6}$/.test(value)) {
    return value.toUpperCase();
  }
  return null;
}

export function serviceIconBadgeStyle(color: string | null | undefined) {
  const hex = normalizeServiceIconColor(color) ?? DEFAULT_SERVICE_ICON_COLOR;
  return {
    backgroundColor: `${hex}1A`,
    color: hex,
  };
}
